module.exports = __webpack_public_path__ + "img/Inspirational Motivator.b2f4b7d0.svg";